import api from "../core/utils/api";
export var handleUnlock = function (_a) {
    var config = _a.config, code = _a.code, personId = _a.personId;
    return new Promise(function (resolve, reject) {
        api.post("/person/".concat(personId, "/unlock"), { code: code }, {
            'X-Widget-Id': config._id,
            'X-Widget-Instance-Id': config._widgetInstanceId,
            'X-Customer-Id': config._customerId,
            'X-Uri': window.location.href,
        })
            .then(function (result) {
            // Do something with the response
            if (result.success === true) {
                resolve(result);
            }
            else {
                reject(result);
            }
        })
            .catch(function (error) {
            console.dir(error);
            reject(error);
        });
    });
};
